import React, { useState, useEffect, Fragment } from "react";
import { Link } from "react-router-dom";
import {
  Button,
  Input,
  FormGroup,
  Col,
  Row,
  Container,
  Label,
  Modal, ModalHeader, ModalBody, ModalFooter, Table,
} from "reactstrap";
import { uniqBy } from "lodash";
import "./index.css";
import ApiCaller from "api/apiCaller";
import Loading from "components/Loading";
import api from "api";
import { UserInfo, UserCompanyListingResponse } from "model/user";
import { ApiResponse, SelectOption } from "model/response";
import {
  Transformation,
  TransformationListingResponse,
} from "model/transformation";
import _ from "lodash";
import ReactPaginate from "react-paginate";
import Select from "react-select";
import TransformationEdit from "../../../Transformations/components/TransformationEdit";

const PAGE_LIMIT = 20;
interface ListingData {
  transformations: Array<Transformation>;
  page: number;
  total: number;
}

interface SelectTransformationModalProps {
  isOpen?: boolean,
  onSelectedTransformationConfirm?: Function,
  onModalClose?: Function,
}

const SelectTransformationModal = ({
  isOpen=false,
  onSelectedTransformationConfirm,
  onModalClose,
}:SelectTransformationModalProps) => {
  const companyId: any = api.getCurrentCompanyId();
  const [currentUser, setCurrentUser] = useState<UserInfo | null>(null);
  const [listingData, setListingData] = useState<ListingData>({
    transformations: [],
    page: 0,
    total: 0,
  });
  const [name, setName] = useState<string>("");
  const [createdFrom, setCreatedFrom] = useState<string>("");
  const [createdTo, setCreatedTo] = useState<string>("");
  const [selectedUser, setSelectedUser] = useState<SelectOption | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [selectedTransformation, setSelectedTransformation] = useState<Array<any>>([]);
  const [showTransformationEdit, setShowTransformationEdit] = useState<boolean>(false);

  useEffect(() => {
    initData();
  }, []);

  useEffect(() => {
    fetchData();
  }, [listingData?.page]);

  const initData = async () => {
    const user = api.getCurrentUser();
    setCurrentUser(user);
    setLoading(false);
  };

  async function fetchData() {
    let url = `transformation/skip_es?company_id=${companyId}&is_delete=0&limit=${PAGE_LIMIT}&page=${listingData?.page}`;
    if (name !== "") {
      url = url + `&name=${name}`;
    }
    if (createdFrom !== "") {
      url = url + `&created_on_from=${createdFrom}`;
    }
    if (createdTo !== "") {
      url = url + `&created_on_to=${createdTo}`;
    }
    if (selectedUser && selectedUser?.value) {
      url = url + `&user_id=${selectedUser?.value}`;
    }
    // setLoading(true)
    const res: ApiResponse = await ApiCaller.get(url);
    if (res?.status === "ok") {
      const data: TransformationListingResponse = res?.data;
      setListingData({
        ...listingData,
        ...{ transformations: data?.transformations, total: data?.total },
      });
      setLoading(false);
    } else {
      setLoading(false);
    }
  }
  const toogleModal = () => {
    if (isModalOpen && onModalClose) {
      onModalClose();
    }
    setIsModalOpen(!isModalOpen);
  };
  const _onTransformationSaved = () => {
    setListingData({
      ...listingData,
      page: 1,
    });
    toogleTransformationEditModal();
  };
  const toogleTransformationEditModal = () => {
    setShowTransformationEdit(!showTransformationEdit);
    setName('');
    setSelectedUser(null);
  }
  const onSelectCheckboxHandler = (checked:any, transformation:Transformation) => {
    let transformationList = [...selectedTransformation];
    if (checked) {
      transformationList.push(transformation);
    } else {
      transformationList = transformationList.filter(t => t.id !== transformation.id);
    }
    setSelectedTransformation(uniqBy(transformationList, 'id'));
  };
  const confirmSelectedTransformation = () => {
    if (onSelectedTransformationConfirm) {
      onSelectedTransformationConfirm(selectedTransformation);
    }
    toogleModal();
  };
  useEffect(() => {
    setIsModalOpen(isOpen);
  }, [isOpen]);
  return (
    <Modal size="lg" isOpen={isModalOpen} toggle={toogleModal}>
      <ModalHeader toggle={toogleModal}>Select transformation</ModalHeader>
      <ModalBody>
        {showTransformationEdit ?
          <TransformationEdit
            onTransformationSaved={_onTransformationSaved}
          />
          :
        <Fragment>
          <Row>
            <Col xs={12}>
              <Button
                color="primary"
                size="sm"
                onClick={toogleTransformationEditModal}
              >
                <span style={{ display: 'flex' }}>
                  <i className="material-icons">add</i>
                  <span>Add new Transformation</span>
                </span>
              </Button>{' '}
              <Button
                size="sm"
                color="info"
                onClick={() => {
                  fetchData();
                }}
              >
                <span style={{ display: 'flex' }}>
                  <i className="material-icons">refresh</i>
                  <span>Refresh</span>
                </span>
              </Button>
            </Col>
          </Row>
          <br />
          <Row>
            <Col xs={12}>
              <FormGroup>
                <Label>Keywords</Label>
                <Input
                  placeholder="Search by query name, SQL..."
                  onChange={(e) => {
                    setName(e.target.value);
                    setListingData({
                      ...listingData,
                      ...{ page: 0 },
                    });
                  }}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={4}>
              <FormGroup>
                <Label>Created From</Label>
                <Input
                  type="date"
                  placeholder=""
                  onChange={(e) => {
                    setCreatedFrom(e.target.value);
                    setListingData({
                      ...listingData,
                      ...{ page: 0 },
                    });
                  }}
                />
              </FormGroup>
            </Col>
            <Col xs={12} sm={4}>
              <FormGroup>
                <Label>Created To</Label>
                <Input
                  type="date"
                  placeholder=""
                  onChange={(e) => {
                    setCreatedTo(e.target.value);
                    setListingData({
                      ...listingData,
                      ...{ page: 0 },
                    });
                  }}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col xs={6}>
              <Button
                size="sm"
                color="primary"
                onClick={() => {
                  fetchData();
                }}
              >
                <span style={{ display: 'flex' }}>
                  <i className="material-icons">search</i>
                  <span>Search</span>
                </span>
              </Button>
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <ReactPaginate
                previousLabel={"<"}
                nextLabel={">"}
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={Math.floor(listingData?.total / PAGE_LIMIT) + 1}
                marginPagesDisplayed={3}
                pageRangeDisplayed={2}
                initialPage={0}
                onPageChange={async (page) => {
                  setListingData({
                    ...listingData,
                    ...{ page: page.selected },
                  });
                }}
                containerClassName={"pagination"}
                activeClassName={"active"}
              />
            </Col>
          </Row>
          <Table>
            <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Table name</th>
                <th>Updated</th>
              </tr>
            </thead>
            <tbody>
              {listingData?.transformations?.map((transformation) => {
                return (
                  <tr key={`${transformation?.id}`}>
                    <th scope="row">
                      <input
                        type="checkbox"
                        onChange={e => onSelectCheckboxHandler(
                          e.target.checked,
                          transformation,
                        )}
                      />
                    </th>
                    <td>
                      <a href={`/transformation/${transformation.id}`} target="_blank">
                        {transformation.name}
                      </a>
                    </td>
                    <td>{transformation.table_name}</td>
                    <td>{transformation.changed_on}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </Fragment>
      }
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={confirmSelectedTransformation}>Select</Button>{' '}
        <Button color="secondary" onClick={toogleModal}>Cancel</Button>
      </ModalFooter>
    </Modal>
  );
}

export default SelectTransformationModal;